import React, { useEffect, useState } from 'react';

import callApi from '../../utils/callApi';
import { ANCHOR_VIEW } from '../../constants/apiUrls/apiUrls';
import SimpleVideoPlayer from '../blogComponents/SimpleVideoPlayer';

import styles from './css/MeetOurAnchorsSection.module.css';
import SubscribeCTAButton from './SubscribeCTAButton';
import { NakedLink } from '../../utils/NakedLink';


const NAKED_NEWS_LIVE_ID = 241;


function MeetOurAnchorsSection(props) {
  const [videoData, setVideoData] = useState({
    videoUrl: null,
    imageUrl: null,
  });
  const {
    sectionContent: {
      heading1,
      heading2,
      content,
      image,
      url,
      logo,
      target,
      rel,
    },
    title,
    user,
    isNNLSection,
    topText,
    url: buttonUrl,
  } = props;

  useEffect(() => {
    if (isNNLSection) {
      const NNL_URL = ANCHOR_VIEW.replace('{id}', NAKED_NEWS_LIVE_ID);
      callApi(NNL_URL, 'get').then((res) => {
        setVideoData({
          videoUrl: res.data.promoClip,
          imageUrl: image,
        });
      }).catch(() => {
        setVideoData({
          videoUrl: '',
          imageUrl: image,
        });
      });
    }
  }, [isNNLSection, image]);

  if (isNNLSection && logo) {
    return (
      <main className={styles.guestHomeMain}>
        <div className={styles.guestSectionLeft}>
          <h2 className={styles.headerText}>{heading1}</h2>
          <div className={styles.description}>
            <p className={styles.description}>{content}</p>
          </div>
          <SubscribeCTAButton alignRight={true} hideOnMobile={true} title={title} topText={topText} link={buttonUrl} />
        </div>
        <div className={styles.guestVideoRight} id="guest-video-right">
          <SimpleVideoPlayer
            key="video_2"
            clip={videoData}
            fanZoneFreeVideo={true}
            isNNLSection={isNNLSection}
            user={user}
          />
        </div>
        <div className={styles.descriptionMobile}>
          <p className={styles.descriptionMobile}>{content}</p>
        </div>
        <SubscribeCTAButton alignRight={true} hideOnMobile={false} title={title} topText={topText} link={buttonUrl} />
      </main>
    );
  }

  return (
    <main className={styles.guestHomeMain}>
      <div className={styles.guestSectionLeft}>
        <div>
          <h2 className={styles.headerText}>
            {heading1}<br />
            <b className={styles.headerText}>{heading2}</b>
          </h2>
        </div>
        <div className={styles.description}>
          <p>{content}</p>
        </div>
        <SubscribeCTAButton alignRight={true} hideOnMobile={true} title={title} topText={topText} link={buttonUrl} />
      </div>
      <NakedLink className={styles.anchorImageGuest} to={url} rel={rel} target={target}>
        <img alt="meet-our-anchors" className={styles.anchorImage} loading="lazy" src={image} />
      </NakedLink>
      <div className={styles.descriptionMobile}>
        <p>{content}</p>
      </div>
      <SubscribeCTAButton alignRight={true} hideOnMobile={false} title={title} topText={topText} link={buttonUrl} />
    </main>
  );
}

export default MeetOurAnchorsSection;
